import { Component, OnInit, HostListener} from '@angular/core';
import { Router } from '@angular/router';
import { AppSettingService, AppService } from '../../app.service';
import { AccountAPIService } from '../account-api.service';
import { UserInfoService } from '../user-info.service';

@Component({
	selector: "app-my-progress",
	templateUrl: "./my-progress.component.html",
	styleUrls: ["./my-progress.scss", "../signupLogin/login.scss"],
	standalone: false
})
export class MyProgressComponent {
	showMinimize:boolean = AppSettingService.widgetMobile();

	@HostListener('window:resize', ['$event']) onResize(event: Event) {
		this.showMinimize = AppSettingService.widgetMobile();
	}
}


@Component({
	selector: "app-my-progress-blocker",
	templateUrl: "./my-progress-blocker.component.html",
	styleUrls: ["../signupLogin/login.scss"],
	standalone: false
})
export class MyProgressBlockerComponent implements OnInit {
	constructor(
		private accountAPI: AccountAPIService,
		private appSrv: AppService,
		private router: Router,
		private userInfo: UserInfoService
	) { }
	pageReady: boolean = false;
	interestComplete: boolean = false;
	skillComplete: boolean = false;
	careerComplete: boolean = false;

	showMinimize = AppSettingService.widgetMobile();

	windowInnerHeight: string = window.innerHeight - 1 + 'px'; //subtract 1 to prevent vertical scrollbar in browser

	@HostListener('window:resize', ['$event'])
	onResize(event: Event) {
		this.showMinimize = AppSettingService.widgetMobile();
	}

	doNext(action: string=""): void {
		switch (action) {
			case 'interest':
				this.router.navigateByUrl("/InterestSurvey/Question");
				break;
			case 'skill':
				this.router.navigateByUrl("/SkillProfiler/Assessment");
				break;
			case 'explore':
				this.router.navigateByUrl("/Career/Exploration");
				break;
			default:
				if (this.userInfo.getHomePage().length > 0) {
					this.appSrv.goTo(this.userInfo.getHomePage());
				}
				break;
		}
	}

	ngOnInit(): void {
		// go to profile dashboard directly if student have done interest or skill or career explort
		this.accountAPI.getMyProgress().subscribe({
			next: (result: any) => {
				if ((result.InterestSurvey ?? "") === "" && (result.SkillAssessment ?? "") === "" && (result.CareerExplore ?? "") === "") {
					this.pageReady = true;
				}
				else {
					this.doNext();
				}
			},
			error: (err: any) => {
				console.log(err);
				this.doNext();
			}
		});
	}
}

